
/*
 * @Author: liumingyang
 * @Date: 2022-05-06 10:50
 * @LastEditors: mingyang_liu 18268117011@163.com
 * @LastEditTime: 2022-07-06 11:13:18
 * @Description: 异常组件封装，包括加载中，加载失败，无数据组件等
 */
import React from "react";
import { useIntl } from 'umi';
import Loading from "@/pages/dashboard/components/Loading";
import NoData from "@/pages/dashboard/components/NoData";
import LoadingFailed from "@/pages/dashboard/components/LoadingFailed";
import './index.scss';
import classNames from "classnames";

type Node = React.Component | React.ReactNode | string
interface AbnormalPropsFace {
  isLoading: boolean;
  componentLoading?: boolean;
  isError?: boolean;
  isNoData?: boolean;
  loadingMsg?: string;
  failedMsg?: string;
  nodataMsg?: Node;
  component?: any;
  style?: any;
  loadClassName?: string;
  className?: string;
  advanceRender?: boolean;
}

const Abnormal = (props: AbnormalPropsFace) => {
  const { formatMessage } = useIntl();
  const {
    isLoading = true,
    componentLoading = false,
    isError = false,
    isNoData = false,
    advanceRender = true, // 提前渲染
    loadingMsg = formatMessage({ id: 'common_loading' }),
    failedMsg = formatMessage({ id: 'common_loading_failed' }),
    nodataMsg = formatMessage({ id: 'common_nodata' }),
    component,
    style,
    loadClassName = '',
    className = ''
  } = props;

  if (isLoading) {
    return (
      <div className={classNames("dbd-loadingCard", loadClassName, className)} style={{
        // height: 300,
        color: '#444',
        borderRadius: 8,
        ...style,
      }}>
        <Loading content={loadingMsg} />
        <div style={{ display: 'none' }}>
          {component}
        </div>
      </div>
    );
  }
  if (isError) {
    return <div className={classNames("dbd-error-card", className)}style={{
      // height: 300,
      color: '#444',
      borderRadius: 8,
      ...style,
    }}><LoadingFailed failedMsg={failedMsg} /></div>;
  }
  if (isNoData && (!componentLoading)) {
    return <div className={classNames("dbd-no-data-card", className)} style={{
      // height: 300,
      color: '#444',
      fontSize: 14,
      borderRadius: 8,
      ...style,
    }}><NoData text={nodataMsg} /></div>;
  }

  return (
    <>
      {
        componentLoading && (
          <div className={classNames("dbd-loading-card", className)} style={{
            // height: 300,
            color: '#444',
            ...style,
          }}>
            <Loading content={loadingMsg} />
          </div>
        )
      }
      {advanceRender ? <div className = {classNames("dbd-component-loading",className)} style={{ display: componentLoading ? 'none' : 'block' }}>{component}</div> :
        !componentLoading ? <div>{component}</div> : null
      }
    </>
  );

};

export default Abnormal;

